module.exports = __webpack_public_path__ + "static/media/bin.99c61e55.svg";